import React, { useEffect, useState } from "react";
import { Check, ArrowRight, Receipt } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import EmbeddedCheckoutModal from "./EmbeddedCheckoutModal";

const L = {
  it: { per_year: "/anno", billed_yearly: "fatturato annualmente", subscribe: "Abbonati", secure: "Pagamento sicuro via Stripe. Disdici quando vuoi." },
  en: { per_year: "/yr", billed_yearly: "billed annually", subscribe: "Subscribe", secure: "Secure payment via Stripe. Cancel anytime." },
};

export default function SubscribePanel() {
  const lang = localStorage.getItem("thoth_lang") || "it";
  const t = L[lang] || L.it;
  const fmtPrice = (n) => {
    if (n == null) return "";
    const s = Number.isInteger(n) ? String(n) : Number(n).toFixed(2);
    return lang === "it" ? s.replace(".", ",") : s;
  };
  const [plan, setPlan] = useState(null);
  const [checkout, setCheckout] = useState(null);

  useEffect(() => {
    api.get("/payments/plans").then(({ data }) => {
      const list = data.plans || [];
      setPlan(list.find((p) => p.id === "pro") || list[0] || null);
    }).catch(() => {});
  }, []);

  const subscribe = () => {
    const lookup_key = plan?.yearly?.lookup_key;
    if (!lookup_key) { toast.error(apiError("Piano non disponibile")); return; }
    setCheckout({ lookup_key });
  };

  if (!plan) return null;
  const feats = (plan.features && plan.features[lang]) || [];
  const price = plan.yearly?.amount;

  return (
    <div data-testid="subscribe-panel">
      <div className="max-w-md mx-auto">
        <div data-testid="subscribe-card-pro" className="relative rounded-3xl p-7 border bg-gradient-to-b from-blue-600/15 to-[#141B27] border-blue-500/40 shadow-2xl shadow-blue-600/20">
          <div className="flex items-center gap-2">
            <Receipt className="w-5 h-5 text-blue-400" />
            <h3 className="font-head font-extrabold text-xl">{plan.name}</h3>
          </div>
          <div className="mt-4 flex items-end gap-1">
            <span className="font-head font-extrabold text-4xl tracking-tight">{fmtPrice(price)}€</span>
            <span className="text-slate-400 mb-1 text-sm">{t.per_year}</span>
          </div>
          <p className="text-xs text-slate-500 mt-1">{t.billed_yearly}</p>
          <button onClick={subscribe} data-testid="subscribe-btn-pro"
            className="mt-5 w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-semibold transition-all bg-blue-600 hover:bg-blue-500 shadow-lg shadow-blue-600/30">
            {t.subscribe} <ArrowRight className="w-4 h-4" />
          </button>
          <ul className="mt-6 space-y-2.5">
            {feats.map((f, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-slate-300">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-emerald-500/15 text-emerald-400 grid place-items-center shrink-0"><Check className="w-3.5 h-3.5" /></span>
                {f}
              </li>
            ))}
          </ul>
          <p className="text-center text-[11px] text-slate-500 mt-5">{t.secure}</p>
        </div>
      </div>
      {checkout && <EmbeddedCheckoutModal lookupKey={checkout.lookup_key} lang={lang} onClose={() => setCheckout(null)} />}
    </div>
  );
}
